// extracted by mini-css-extract-plugin
module.exports = {"chip":"jgp-1klha","icon":"jgp-srfdn"};